import React from 'react';

const AnimatedCard = ({ children, direction = 'bottom', delay = 0 }) => {
  const animationClass =
    direction === 'top' ? 'card-fade-in-top' : 'card-fade-in-bottom';

  return (
    <div className={animationClass} style={{ animationDelay: `${delay}s`,width:'100%' }}>
      {children}
    </div>
  );
};

export default AnimatedCard;